module.exports = __webpack_public_path__ + "img/level_one_hover.66d42da2.png";